import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/accelerator/page.tsx");
